export default __webpack_public_path__ + "static/media/delete.f0eaf09a.svg";